const setResumePublications = (publications) => ({
    type: 'SET_RESUME_PUBLICATIONS',
    publications,
});

export default setResumePublications;
